import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import AuthService from "../services/AuthService";
import StorageService from '../services/StorageService';
import utility from '../utils/utility';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {

  // Removed successMessage and errorMessage states
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [sessionExpiredMessage, setSessionExpiredMessage] = useState('');

  const navigate = useNavigate();
  const { user, login } = useAuth();

  useEffect(() => {
    // Check if user is already logged in
    if (user) {
      navigate("/cpnl/dashboard");
    }
  }, [user, navigate]);

  // Check for token expiration message on component mount
  useEffect(() => {
    const tokenExpired = localStorage.getItem('tokenExpired');
    if (tokenExpired) {
      setSessionExpiredMessage('Your session has expired. Please login again.');
      localStorage.removeItem('tokenExpired');
      // Show the message for a few seconds then clear it
      setTimeout(() => {
        setSessionExpiredMessage('');
      }, 5000);
    }

    // Listen for token expiration events from API interceptor
    const handleTokenExpired = (event) => {
      setSessionExpiredMessage(event.detail?.message || 'Your session has expired. Please login again.');
      utility.showError(event.detail?.message || 'Your session has expired. Please login again.');
      setTimeout(() => {
        setSessionExpiredMessage('');
      }, 5000);
    };

    window.addEventListener('tokenExpired', handleTokenExpired);
    return () => window.removeEventListener('tokenExpired', handleTokenExpired);
  }, []);

  const handleLogin = async () => {
    setLoading(true);

    try {
      const res = await AuthService.login({ staffCode: email, password: password });

      if (res.success) {
        // Use the login function from AuthContext
        login(res.data.staff, res.data.token);
        utility.showSuccess("Login Successful!");
        navigate("/cpnl/dashboard");
      } else {
        const msg = res.message || "Invalid email or password";
        utility.showError(msg);
      }
    } catch (err) {
      utility.showError(err.message);
    }

    setLoading(false);
  }
  return (
    <main className="main-content mt-0 ps">
      <div className="page-header align-items-start min-vh-100" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1497294815431-9365093b7331?ixlib=rb-1.2.1&amp;ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&amp;auto=format&amp;fit=crop&amp;w=1950&amp;q=80');" }}>

        <span className="mask "></span>
        <div className="container my-auto">
          <div className="row">

            <div className="col-lg-4 col-md-8 col-12 mx-auto">

              <div className="card z-index-0 fadeIn3 fadeInBottom">
                <img src="https://mahavedika.com/images/MV-LOGO-Lg.png" className="mb-2 navbar-brand-img" alt="main_logo" />
                {/* <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                  <div class="bg-gradient-dark shadow-dark border-radius-lg py-3 pe-1">
                    <h4 class="text-white font-weight-bolder text-center mt-2 mb-0">Sign in</h4>
                    <div class="row mt-3">
                      <div class="col-2 text-center ms-auto">
                        <a class="btn btn-link px-3" href="#">
                          <i class="fa fa-facebook text-white text-lg"></i>
                        </a>
                      </div>
                      <div class="col-2 text-center px-1">
                        <a class="btn btn-link px-3" href="#">
                          <i class="fa fa-github text-white text-lg"></i>
                        </a>
                      </div>
                      <div class="col-2 text-center me-auto">
                        <a class="btn btn-link px-3" href="#">
                          <i class="fa fa-google text-white text-lg"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div class="card-body">
                  {/* Session Expired Message */}
                  {sessionExpiredMessage && (
                    <div className="alert alert-warning alert-dismissible fade show mb-3" role="alert">
                      <strong>Session Expired:</strong> {sessionExpiredMessage}
                      <button type="button" className="btn-close" onClick={() => setSessionExpiredMessage('')}></button>
                    </div>
                  )}
                  <form role="form" class="text-start">
                    <div class="input-group input-group-outline my-3">
                      {/* <label class="form-label">Email</label> */}
                      <input type="email" class="form-control" placeholder='Email / Mobile No' onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div class="input-group input-group-outline mb-3">
                      {/* <label class="form-label">Password</label> */}
                      <input type="password" class="form-control" placeholder='Password' onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    <div class="form-check form-switch d-flex align-items-center mb-3">
                      <input class="form-check-input" type="checkbox" id="rememberMe" checked="" />
                      <label class="form-check-label mb-0 ms-3" for="rememberMe">Remember me</label>
                    </div>
                    <div class="text-center">
                      <button type="button" class="btn bg-gradient-dark w-100 my-4 mb-2" onClick={handleLogin} disabled={loading}>
                        {loading ? 'Signing in...' : 'Sign in'}
                      </button>
                    </div>
                    {/* <p class="mt-4 text-sm text-center">
                      Don't have an account?
                      <a href="../pages/sign-up.html" class="text-primary text-gradient font-weight-bold">Sign up</a>
                    </p> */}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="footer position-absolute bottom-2 py-2 w-100">
          <div class="container">
            <div class="row align-items-center justify-content-lg-between">
              <div class="col-12 col-md-6 my-auto">
                <div class="copyright text-center text-sm text-white text-lg-start">
                  © <script>
                    document.write(new Date().getFullYear())
                  </script>2026,
                  made with <i class="fa fa-heart" aria-hidden="true"></i> by
                  <a href="https://www.creative-tim.com" class="font-weight-bold text-white" target="_blank">Creative Tim</a>
                  for a better web.
                </div>
              </div>
              <div class="col-12 col-md-6">
                <ul class="nav nav-footer justify-content-center justify-content-lg-end">
                  <li class="nav-item">
                    <a href="https://www.creative-tim.com" class="nav-link text-white" target="_blank">Creative Tim</a>
                  </li>
                  <li class="nav-item">
                    <a href="https://www.creative-tim.com/presentation" class="nav-link text-white" target="_blank">About Us</a>
                  </li>
                  <li class="nav-item">
                    <a href="https://www.creative-tim.com/blog" class="nav-link text-white" target="_blank">Blog</a>
                  </li>
                  <li class="nav-item">
                    <a href="https://www.creative-tim.com/license" class="nav-link pe-0 text-white" target="_blank">License</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
      </div>
      <div class="ps__rail-x" style={{ left: "0px", bottom: "0px" }}><div class="ps__thumb-x" tabindex="0" style={{ left: "0px", width: "0px" }}></div></div><div class="ps__rail-y" style={{ top: "0px", right: "0px" }}><div class="ps__thumb-y" tabindex="0" style={{ top: "0px", height: "0px" }}></div></div></main>
  );
};

export default Login;
